module.exports = __webpack_public_path__ + "static/media/33.6618d887.png";